import React, { Component } from 'react'

import withCssClassName from '../with-css-class-name'

class MessageaudienceIcon extends Component {
    render() {
        return (
            <svg {...this.props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 16"><path d="M5.2 12.8C5.4 10.2 7 8.1 9 8.1s3.6 2.1 3.8 4.7H5.2zm11.8-.9h-3.3c-.2-1.1-.7-2-1.3-2.6.5-.4 1-.7 1.6-.7 1.5 0 2.7 1.4 3 3.3zm-16 0c.3-1.9 1.5-3.3 3-3.3.6 0 1.2.2 1.6.7-.6.6-1 1.5-1.3 2.6H1zm8-4.3c-1.6 0-2.8-1.3-2.8-2.8S7.4 2 9 2s2.8 1.3 2.8 2.8S10.6 7.6 9 7.6zm-5.2.5c-1 0-1.9-.8-1.9-1.9s.8-1.9 1.9-1.9 1.9.8 1.9 1.9-.8 1.9-1.9 1.9zm10.4 0c-1 0-1.9-.8-1.9-1.9s.8-1.9 1.9-1.9 1.9.8 1.9 1.9-.9 1.9-1.9 1.9z" fill="#b9c2c5"/></svg>
        )
    }
}

export default withCssClassName(MessageaudienceIcon)



// WEBPACK FOOTER //
// src/components/svg-icon/icons/messageaudience-icon.js